import { safetyContent } from '@/mocks/content';

export default function SafetySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-14">
          <div className="w-full lg:w-[45%]">
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-3">Sicurezza</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-[1.15] mb-5">
              {safetyContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {safetyContent.paragraphs[0]}
            </p>
          </div>

          <div className="w-full lg:w-[55%] lg:pl-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {safetyContent.checklist.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 px-4 py-3.5 rounded-lg bg-background-50/80"
                >
                  <div className="w-7 h-7 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm text-accent-600"></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}